import {UIState} from "../../../data/UIState";
import {observer} from "mobx-react";
import * as React from "react";
import {action, observable} from "mobx";
import {NavAvatar} from "../../nav/NavAvatar";

import './CommentReplyAdd.pcss';
import {Alert} from "../../../data/Alert";

interface Props {
  originalCommenter:string;
  addReply:(reply:string)=>Promise<void>;
}

@observer
export class CommentReplyAdd extends React.Component<Props> {
  @observable active = false;
  @observable replying = false;
  @observable reply:string;
  textareaRef;

  constructor(props:Props) {
    super(props);
    this.textareaRef = React.createRef();
  }

  @action toggleActive = () => {
    if(!this.replying) {
      if (this.active) {
        this.clear();
      } else {
        this.active = true;
        setTimeout(()=>{
          if(this.textareaRef.current) {
            this.textareaRef.current.focus();
          }
        }, 10);
      }
    }
  }

  @action handleAddReply = () => {
    if(!this.replying) {
      this.replying = true;
      this.props.addReply(this.reply)
      .then(() => {
        this.clear();
        this.replying = false;
      })
      .catch((err) => {
        this.replying = false;
        console.log(err);
        Alert.alert("Failed to submit reply! Please make sure that you are connected to teh Internet and try again.")
      });
    }
  }

  @action clear = () => {
    this.textareaRef.current.innerHTML = '';
    this.reply = '';
    this.active = false;
  }

  render(){
    return (
        <div className={`comment-reply-add${this.active?' active':''}`}>
          {this.active ?
            <>
              <h3>Reply to {this.props.originalCommenter}</h3>
              <div className={'cra-form'}>
                <div className={"craf-avatar"}>
                  <NavAvatar user={UIState.user} variant={'xsmall'} />
                </div>
                <div className={"craf-inputs"}>
                  <span
                      ref={this.textareaRef}
                      className={'cra-textarea'}
                      role="textbox"
                      contentEditable
                      onInput={action((event)=>{
                        if(!this.replying) {
                          this.reply = event.currentTarget.textContent?event.currentTarget.textContent:'';
                        }
                      })}
                      onFocus={()=>{
                        this.active = true;
                      }}
                  ></span>
                  <div className={"cra-actions"}>
                    <a className="cra-btn reply" onClick={this.handleAddReply}>Reply</a>
                    <a className="cra-btn cancel" onClick={this.toggleActive}>Cancel</a>
                  </div>
                </div>

              </div>
            </>
          :
            <a href={"#"} className={"cra-reply"} onClick={this.toggleActive}>Reply</a>
          }
        </div>
    );
  }

}
